import React from 'react'
import { Box } from '@mui/joy'
import { getSubjectColor, getSubjectIcon } from 'app/utils'

type Props = {
  subject?: string
}

const SubjectIcon = ({ subject }: Props) => {
  const subjectColor = getSubjectColor(subject);

  return (
    <Box
      sx={{
        width: 70,
        height: 70,
        borderRadius: '16px',
        backgroundColor: subjectColor[100],
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'transform 0.4s ease-in-out',
        '&:hover ': {
          transform: 'scale(1.1)',
        },
      }}
    >
      {getSubjectIcon(subject)}
    </Box>
  )
}

export default SubjectIcon